jQuery(function ($) {
    'use strict';

    /**
     * ============================================================================
     * GRAVITY FORMS MULTI-STEP HANDLER
     * Generic utilities for multi-step Gravity Forms (progress, announcements, etc.)
     * ============================================================================
     */
    const GravityFormsMultiStep = {
        /**
         * Update Gravity Forms progress bar
         */
        setProgress: function($wrapper, currentPage) {
            const $bar = $wrapper.find('.gf_progressbar');
            if (!$bar.length) return;
            const totalPages = Math.max($wrapper.find('.gform_page').length, 1);
            const pct = Math.round((currentPage / totalPages) * 100);

            $bar.removeClass('gf_progressbar_complete');

            const $pctBar = $bar.find('.gf_progressbar_percentage');
            $pctBar.css('width', pct + '%').attr({ 'aria-valuemin': 0, 'aria-valuemax': 100, 'aria-valuenow': pct });
            const $pctText = $pctBar.find('.percent');
            if ($pctText.length) $pctText.text(pct + '%');

            const $steps = $bar.find('.gf_step');
            if ($steps.length) {
                $steps.removeClass('gf_step_active gf_step_completed gf_step_completed_tail').removeAttr('aria-current');
                $steps.filter((i) => i + 1 < currentPage).addClass('gf_step_completed');
                const idx = Math.min(currentPage - 1, $steps.length - 1);
                $steps.eq(idx).addClass('gf_step_active').attr('aria-current', 'step');
            }
        },

        /**
         * Ensure screen reader announcer exists
         */
        ensureAnnouncer: function($scope) {
            let $live = $('#gf-step-announcer');
            if (!$live.length) {
                $live = $('<div id="gf-step-announcer" role="status" aria-live="polite" class="sr-only" />')
                    .appendTo($scope || document.body);
            }
            return $live;
        },

        /**
         * Announce current step to screen readers
         */
        announceStep: function($wrapper, page) {
            const $pages = $wrapper.find('.gform_page');
            const total  = Math.max($pages.length, 1);
            const title  = $pages.eq(Math.max(page - 1, 0))
                .find('.gform_page_title:first, h1:first, h2:first, h3:first, legend:first')
                .text().trim() || '';
            this.ensureAnnouncer().text(`Step ${page} of ${total}${title ? `: ${title}` : ''}`);
        },

        /**
         * Reset form to page 1 and clear all inputs
         */
        resetToStart: function($formContainer, strictClear = true) {
            const $gf = $formContainer.find('form[id^="gform_"]').first();
            if (!$gf.length) return;

            $gf.attr('autocomplete', 'off').find('input,select,textarea').attr('autocomplete', 'off');

            const idMatch = ($gf.attr('id') || '').match(/gform_(\d+)/);
            const formId = idMatch ? parseInt(idMatch[1], 10) : null;
            const $wrapper = $gf.closest('.gform_wrapper');

            if ($gf[0]?.reset) $gf[0].reset();

            if (strictClear) {
                $gf.find('input[type="text"],input[type="email"],input[type="tel"],input[type="url"],input[type="search"],input[type="number"],input[type="password"],input[type="date"],input[type="time"],input[type="datetime-local"],input[type="month"],input[type="week"],textarea')
                   .val('').trigger('input change');
                $gf.find('input[type="radio"],input[type="checkbox"]')
                   .prop('checked', false).removeAttr('checked').prop('aria-checked', false).trigger('change');
                $gf.find('select').each(function () {
                    const $sel = $(this);
                    const $empty = $sel.find('option[value=""], option:not([value])').first();
                    this.selectedIndex = $empty.length ? $empty.index() : 0;
                    $sel.trigger('change');
                });
                $gf.find('input[type="file"]').val('');
            }

            $wrapper.find('.validation_error, .validation_message, .gfield_validation_message').remove();
            $wrapper.find('.gfield_error').removeClass('gfield_error');

            const $pages = $wrapper.find('.gform_page');
            if ($pages.length) {
                $pages.hide().first().show();
                if (formId) {
                    $gf.find(`input[name="gform_target_page_number_${formId}"]`).val('1');
                    $gf.find(`input[name="gform_source_page_number_${formId}"]`).val('1');
                }
                this.setProgress($wrapper, 1);
                this.announceStep($wrapper, 1);
            }
        }
    };

    /**
     * ============================================================================
     * SCROLL POSITION MANAGER
     * Prevents page jumping during AJAX form transitions
     * ============================================================================
     */
    const ScrollPositionManager = {
        savedPosition: null,
        locked: false,
        originalScrollTo: null,

        save: function() {
            this.savedPosition = { x: window.scrollX, y: window.scrollY };
            this.locked = true;

            // Override window.scrollTo to prevent ANY scrolling during transition
            if (!this.originalScrollTo) {
                this.originalScrollTo = window.scrollTo;
                window.scrollTo = (x, y) => {
                    if (this.locked && this.savedPosition) return;
                    this.originalScrollTo.call(window, x, y);
                };
            }

            // Add passive listener to force scroll position during lock
            const lockScroll = () => {
                if (this.locked && this.savedPosition) {
                    window.scrollTo = this.originalScrollTo;
                    this.originalScrollTo.call(window, this.savedPosition.x, this.savedPosition.y);
                    window.scrollTo = (x, y) => {
                        if (this.locked && this.savedPosition) return;
                        this.originalScrollTo.call(window, x, y);
                    };
                }
            };

            window.addEventListener('scroll', lockScroll, { passive: true });
            setTimeout(() => window.removeEventListener('scroll', lockScroll), 200);
        },

        restore: function() {
            if (this.savedPosition === null) return;

            const pos = this.savedPosition;

            // Restore original scrollTo
            if (this.originalScrollTo) {
                window.scrollTo = this.originalScrollTo;
            }

            // Multiple restore attempts to override any forced scrolls
            window.scrollTo(pos.x, pos.y);
            requestAnimationFrame(() => window.scrollTo(pos.x, pos.y));
            
            setTimeout(() => {
                window.scrollTo(pos.x, pos.y);
                this.savedPosition = null;
                this.locked = false;
                this.originalScrollTo = null;
            }, 10);
        },

        restoreDelayed: function() {
            const pos = this.savedPosition ? {...this.savedPosition} : null;
            if (pos) {
                setTimeout(() => window.scrollTo(pos.x, pos.y), 20);
                setTimeout(() => window.scrollTo(pos.x, pos.y), 50);
                setTimeout(() => window.scrollTo(pos.x, pos.y), 100);
            }
        },

        handleLock: function() {
            if (this.locked && this.savedPosition) {
                window.scrollTo(this.savedPosition.x, this.savedPosition.y);
            }
        }
    };

    /**
     * ============================================================================
     * ANCHORED MODAL SYSTEM
     * Creates expandable form modals that stay anchored on desktop, fullscreen on mobile
     * ============================================================================
     */
    function createAnchoredModal(config) {
        const defaults = {
            wrapSelector: null,          // Required: modal wrapper
            contentSelector: null,       // Required: initial content
            formSelector: '.modal-form',  // Form panel (any element with .modal-form inside the wrapper)
            buttonSelector: '.modal-trigger', // Open button (any element with .modal-trigger inside the wrapper)
            closeSelector: null,         // Optional: override close button selector (default: .modal-close within wrapper)
            bodyActiveClass: 'modal-anchored-open',
            namespace: '.anchoredModal',
            inputNamespace: '.inputMode',
            mobileBreakpoint: '575.98px',
            fadeMs: 220,
            heightMs: 260,
            strictClear: true
        };

        const settings = { ...defaults, ...config };
        
        // Required validation
        if (!settings.wrapSelector || !settings.contentSelector) {
            console.error('AnchoredModal: Missing required selectors', settings);
            return null;
        }

        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const fadeMs   = prefersReduced ? 0 : settings.fadeMs;
        const heightMs = prefersReduced ? 0 : settings.heightMs;
        const NS = settings.namespace;
        const NS_INPUT = settings.inputNamespace;

        // Cached references
        const $docBody = $(document.body);

        // Style helpers — reduce repeated style.setProperty / removeProperty chains
        const setStyles = (node, props, priority = '') =>
            Object.entries(props).forEach(([k, v]) => node.style.setProperty(k, v, priority));
        const removeStyles = (node, ...props) =>
            props.forEach(prop => node.style.removeProperty(prop));

        // DOM refs
        const $wrap  = $(settings.wrapSelector);
        const $body  = $wrap.find(settings.contentSelector);
        const $form  = $wrap.find(settings.formSelector);
        const $btn   = $wrap.find(settings.buttonSelector);
        const $close = $wrap.find(settings.closeSelector || '.modal-close');

        if (!$wrap.length || !$body.length || !$form.length || !$btn.length) {
            console.error('AnchoredModal: Required elements not found', settings);
            return null;
        }

        // State
        let $anchor = null;
        let overlayOpen = false;
        let rafId = null;

        // Input tracking for auto-advance
        let lastKey = null;
        let lastKeyTs = 0;
        let lastPointerTs = 0;

        // Helpers
        const isMobile = () => window.matchMedia(`(max-width: ${settings.mobileBreakpoint})`).matches;

        function applyMobileStyles(node) {
            setStyles(node, {
                top: '0px', left: '0px', width: '100%', height: '100vh',
                'border-radius': '0', 'overflow-y': 'auto',
                '-webkit-overflow-scrolling': 'touch'
            }, 'important');
        }

        function clearMobileStyles(node) {
            removeStyles(node, 'height', 'border-radius', 'overflow-y', '-webkit-overflow-scrolling');
        }

        function focusFirstFormControl() {
            const $focusable = $form.find('.gform_wrapper :input:enabled:visible')
                .add($form.find('a[href], button:enabled, [tabindex]:not([tabindex="-1"])'))
                .filter(':visible')
                .first();
            ($focusable.length ? $focusable : $form).trigger('focus');
        }

        function getContentBoxHeights(el) {
            const cs = window.getComputedStyle(el);
            const pt = parseFloat(cs.paddingTop) || 0;
            const pb = parseFloat(cs.paddingBottom) || 0;
            return {
                startContent: el.clientHeight - pt - pb,
                targetContent: el.scrollHeight - pt - pb
            };
        }

        function syncOverlayToAnchor() {
            if (isMobile() || !overlayOpen || !$anchor?.length) return;
            const rect = $anchor[0].getBoundingClientRect();
            setStyles($wrap[0], {
                top:   Math.round(rect.top)   + 'px',
                left:  Math.round(rect.left)  + 'px',
                width: Math.round(rect.width) + 'px'
            }, 'important');
        }

        function onScrollOrResize() {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = null;
                const node = $wrap[0];
                if (!overlayOpen) return;

                if (isMobile()) {
                    applyMobileStyles(node);
                } else {
                    clearMobileStyles(node);
                    syncOverlayToAnchor();
                }
            });
        }

        function startHeightStabilizer(finalize) {
            if (isMobile()) { if (typeof finalize === 'function') finalize(); return; }
            const node = $wrap[0];
            node.style.setProperty('transition', `height ${heightMs}ms ease`);
            let last = -1;
            let stableFrames = 0;
            const maxMs = 900;
            const needStableFrames = 4;
            const t0 = performance.now();

            function tick() {
                if (!overlayOpen) return;
                const { targetContent } = getContentBoxHeights(node);
                if (Math.abs(targetContent - last) > 0.5) {
                    $wrap.height(targetContent);
                    last = targetContent;
                    stableFrames = 0;
                } else {
                    stableFrames++;
                }
                const elapsed = performance.now() - t0;
                if (stableFrames < needStableFrames && elapsed < maxMs) {
                    requestAnimationFrame(tick);
                } else {
                    node.style.removeProperty('transition');
                    if (typeof finalize === 'function') finalize();
                }
            }
            requestAnimationFrame(tick);
        }

        /**
         * Setup Gravity Forms handlers — auto-detects form ID, multi-step, and auto-advance from DOM
         */
        function setupGravityFormsHandlers() {
            // Auto-detect the GF inside the form container
            const $gf = $form.find('form[id^="gform_"]').first();
            if (!$gf.length) return;

            const idMatch = ($gf.attr('id') || '').match(/gform_(\d+)/);
            const formId  = idMatch ? parseInt(idMatch[1], 10) : null;
            if (!formId) return;

            const $gfWrapper  = $gf.closest('.gform_wrapper');
            const isMultiStep = $gfWrapper.find('.gform_page').length > 1;
            const hasAutoAdv  = isMultiStep && $form.find('.gf-auto-advance').length > 0;

            // Track input method for auto-advance (only when needed)
            if (hasAutoAdv) {
                $(document)
                    .off('keydown' + NS_INPUT + ' mousedown' + NS_INPUT + ' touchstart' + NS_INPUT)
                    .on('keydown' + NS_INPUT, (e) => { lastKey = e.key; lastKeyTs = Date.now(); })
                    .on('mousedown' + NS_INPUT + ' touchstart' + NS_INPUT, () => { lastPointerTs = Date.now(); });

                // Auto-advance on radio selection
                $wrap.on('change' + NS, '.gf-auto-advance :input', function () {
                    if (!overlayOpen) return;

                    const now = Date.now();
                    const recentPointer    = now - lastPointerTs < 600;
                    const recentConfirmKey = now - lastKeyTs < 600 && (lastKey === 'Enter' || lastKey === ' ' || lastKey === 'Spacebar');
                    const recentArrow      = now - lastKeyTs < 600 && ['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(lastKey);
                    if (!(recentPointer || recentConfirmKey) || recentArrow) return;

                    const $currentGf = $form.find(`#gform_${formId}`).first();
                    if (!$currentGf.length) return;

                    const $wrapper = $currentGf.closest('.gform_wrapper');
                    const $pages   = $wrapper.find('.gform_page');
                    const $visible = $pages.filter(':visible').first();
                    const isLast   = $pages.index($visible) === $pages.length - 1;

                    const $nextBtn   = $visible.find('.gform_page_footer .gform_next_button, .gform_page_footer [id^="gform_next_button_"]').first();
                    const $submitBtn = $currentGf.find('.gform_footer .gform_button[type="submit"], .gform_footer [id^="gform_submit_button_"]').first();

                    setTimeout(() => {
                        if (!isLast && $nextBtn.length) $nextBtn.trigger('click');
                        else if (isLast && $submitBtn.length) $submitBtn.trigger('click');
                        else {
                            ScrollPositionManager.save();
                            const curIdx = Math.max($pages.index($visible), 0);
                            $currentGf.find(`input[name="gform_source_page_number_${formId}"]`).val(curIdx + 1);
                            $currentGf.find(`input[name="gform_target_page_number_${formId}"]`).val(isLast ? '0' : (curIdx + 2));
                            $currentGf.trigger('submit');
                        }
                    }, 160);
                });
            }

            // Save scroll position before GF page navigation buttons (multi-step only)
            if (isMultiStep) {
                $(document).on('click' + NS, '.gform_next_button, .gform_previous_button, .gform_button[type="submit"]', function () {
                    if (!overlayOpen) return;
                    if ($(this).closest('form').attr('id') === `gform_${formId}`) {
                        ScrollPositionManager.save();
                    }
                });
            }

            // For single-step forms, save scroll on submit so GF can't scroll after AJAX
            if (!isMultiStep) {
                $(document).on('click' + NS, `.gform_wrapper #gform_${formId} .gform_button[type="submit"]`, function () {
                    if (!overlayOpen) return;
                    ScrollPositionManager.save();
                });
            }

            // Handle GF confirmation loaded — restore scroll and re-stabilize height
            $(document).on('gform_confirmation_loaded' + NS, function (e, confirmedFormId) {
                if (confirmedFormId && confirmedFormId != formId) return;
                if (!overlayOpen) return;
                ScrollPositionManager.restore();
                ScrollPositionManager.restoreDelayed();
                if (!isMobile()) startHeightStabilizer();
            });

            // Handle GF render/page-change events
            $(document).on('gform_post_render' + NS + ' gform_page_loaded' + NS, function (e, renderedFormId) {
                if (renderedFormId && renderedFormId != formId) return;
                if (!overlayOpen) return;

                const $currentGf = $form.find(`#gform_${formId}`).first();
                if (!$currentGf.length) return;

                if (!isMobile()) startHeightStabilizer();

                if (isMultiStep) {
                    const $wrapper = $currentGf.closest('.gform_wrapper');
                    const $pages   = $wrapper.find('.gform_page');
                    const $visible = $pages.filter(':visible').first();
                    const $title   = $visible.find('.gform_page_title:first, h1:first, h2:first, h3:first, legend:first');

                    if ($title.length) {
                        const had = $title.attr('tabindex');
                        $title.attr('tabindex', '-1');
                        $title[0].focus({ preventScroll: true });
                        if (had === undefined) $title.removeAttr('tabindex');
                    } else {
                        const $first = $visible.find(':input:enabled:visible').first();
                        if ($first.length) $first[0].focus({ preventScroll: true });
                    }

                    const idx = Math.max($pages.index($visible), 0);
                    GravityFormsMultiStep.setProgress($wrapper, idx + 1);
                    GravityFormsMultiStep.announceStep($wrapper, idx + 1);

                    ScrollPositionManager.restore();
                    ScrollPositionManager.restoreDelayed();
                }
            });
        }

        /**
         * Bind modal lifecycle event handlers
         */
        function bindDismissHandlers() {
            $(document)
                .on(`mousedown${NS} touchstart${NS}`, e => {
                    if (!$(e.target).closest(settings.wrapSelector).length) close();
                })
                .on(`keydown${NS}`, e => { if (e.key === 'Escape') close(); });

            // Image load triggers height recalc
            $form.find('img').each(function () {
                if (this.complete) return;
                $(this).one(`load${NS} error${NS}`, function () {
                    if (overlayOpen && !isMobile()) startHeightStabilizer();
                });
            });

            $(window)
                .on(`scroll${NS}`, () => ScrollPositionManager.handleLock())
                .on(`scroll${NS}`, onScrollOrResize)
                .on(`resize${NS}`, onScrollOrResize);
        }

        function unbindDismissHandlers() {
            $(document).off(NS);
            $form.find('img').off(NS);
            $(window).off(`scroll${NS}`).off(`resize${NS}`);
        }

        /**
         * Open modal (desktop: anchored; mobile: fullscreen)
         */
        function open() {
            if (overlayOpen || $btn.is('[aria-disabled="true"]')) return;
            $btn.attr('aria-disabled', 'true');

            $wrap.stop(true, true); $body.stop(true, true); $form.stop(true, true);

            $body.show().css('opacity', 1);
            $form.hide().css('opacity', 0);

            // Create anchor placeholder
            const outerH = $wrap.outerHeight();
            $anchor = $('<div/>', { 
                'class': ($wrap.attr('class') || '') + ' modal-anchor', 
                'aria-hidden': 'true' 
            }).css({ height: outerH, visibility: 'hidden', boxShadow: 'none', background: 'transparent' });

            $wrap.after($anchor);
            $wrap.detach();
            $docBody.append($wrap);

            const node = $wrap[0];
            setStyles(node, { position: 'fixed', 'z-index': '10000', margin: '0' }, 'important');
            node.style.setProperty('will-change', 'height');

            if (isMobile()) {
                applyMobileStyles(node);
            } else {
                clearMobileStyles(node);
                const rect = $anchor[0].getBoundingClientRect();
                setStyles(node, {
                    top:   Math.round(rect.top)   + 'px',
                    left:  Math.round(rect.left)  + 'px',
                    width: Math.round(rect.width) + 'px'
                }, 'important');

                const { startContent } = getContentBoxHeights(node);
                $wrap.css({ height: startContent, overflow: 'hidden' });
            }

            const prevBodyPos = $body.css('position');
            $body.css({ position: 'absolute', inset: 0, width: '100%' });
            $form.show().css('opacity', 0);

            $body.attr('aria-hidden', 'true');
            $form.attr('aria-hidden', 'false');
            $docBody.addClass(settings.bodyActiveClass);

            overlayOpen = true;
            bindDismissHandlers();
            setupGravityFormsHandlers();

            // Crossfade
            $body.animate({ opacity: 0 }, fadeMs);
            $form.animate({ opacity: 1 }, fadeMs);

            // Initialize GF progress if form is multi-step (auto-detected)
            const $openGf = $form.find('form[id^="gform_"]').first();
            if ($openGf.length) {
                const $wrapper = $openGf.closest('.gform_wrapper');
                const $pages = $wrapper.find('.gform_page');
                if ($pages.length > 1) {
                    const visibleIndex = Math.max($pages.index($pages.filter(':visible')), 0);
                    GravityFormsMultiStep.setProgress($wrapper, visibleIndex + 1);
                    GravityFormsMultiStep.announceStep($wrapper, visibleIndex + 1);
                }
            }

            // Height stabilize (desktop only)
            startHeightStabilizer(() => {
                $wrap.css({ overflow: isMobile() ? 'auto' : '', willChange: '' });
                $body.hide().css({ opacity: 1, position: prevBodyPos, inset: '', width: '' });
                $form.css('opacity', 1);
                $btn.attr({ 'aria-expanded': 'true' }).removeAttr('aria-disabled');
                focusFirstFormControl();
            });

            requestAnimationFrame(syncOverlayToAnchor);
        }

        /**
         * Close modal (desktop: fixed shrink + swap; mobile: simple fade + swap)
         */
        function close() {
            if (!overlayOpen) return;

            $docBody.removeClass(settings.bodyActiveClass);
            unbindDismissHandlers();

            $wrap.stop(true, true); $body.stop(true, true); $form.stop(true, true);

            const node = $wrap[0];

            // Crossfade prep
            $body.show().css({ opacity: 0, position: 'static', inset: '', width: '' });
            $form.css({ opacity: 1, position: 'absolute', inset: 0, width: '100%' });

            if (isMobile()) {
                // Mobile: keep fullscreen fixed; just fade and swap back
                $.when(
                    $form.animate({ opacity: 0 }, fadeMs).promise(),
                    $body.animate({ opacity: 1 }, fadeMs).promise()
                ).done(function () {
                    if (settings.gravityFormId) {
                        GravityFormsMultiStep.resetToStart($form, settings.strictClear);
                    }

                    // Restore to flow
                    removeStyles(node, 'position', 'top', 'left', 'width', 'height', 'z-index', 'margin',
                        'overflow-y', '-webkit-overflow-scrolling', 'will-change', 'border-radius');

                    if ($anchor?.length) { $anchor.replaceWith($wrap); $anchor = null; }

                    $body.show().css({ opacity: 1, position: '', inset: '', width: '' });
                    $form.hide().css({ opacity: 1, position: '', inset: '', width: '' });

                    $body.attr('aria-hidden', 'false');
                    $form.attr('aria-hidden', 'true');
                    $btn.attr('aria-expanded', 'false').removeAttr('aria-disabled');

                    overlayOpen = false;
                    $btn.trigger('focus');
                });
                return;
            }

            // Desktop: fixed shrink (page behind stays still)
            void node.offsetHeight;
            const cs = window.getComputedStyle(node);
            const pt = parseFloat(cs.paddingTop) || 0;
            const pb = parseFloat(cs.paddingBottom) || 0;
            const bt = parseFloat(cs.borderTopWidth) || 0;
            const bb = parseFloat(cs.borderBottomWidth) || 0;

            const targetContent = node.scrollHeight - pt - pb;
            const targetOuter   = targetContent + pt + pb + bt + bb;
            const currentOuter  = ($anchor && $anchor.length) ? $anchor.outerHeight() : $wrap.outerHeight();
            const scrollAdjust  = Math.max(0, currentOuter - targetOuter);

            node.style.setProperty('transition', 'none');
            $wrap.css({ height: $wrap.height(), overflow: 'hidden', willChange: 'height' });

            const heightAnim = $wrap.animate({ height: targetContent }, heightMs, 'swing').promise();
            const fadeOut    = $form.animate({ opacity: 0 }, fadeMs).promise();
            const fadeIn     = $body.animate({ opacity: 1 }, fadeMs).promise();

            $.when(heightAnim, fadeOut, fadeIn).done(function () {
                if ($anchor && $anchor.length) {
                    removeStyles(node, 'top', 'left', 'width', 'z-index', 'margin', 'position');
                    setStyles(node, { height: targetContent + 'px', overflow: 'hidden', 'will-change': 'height' });

                    $anchor.replaceWith($wrap);
                    $anchor = null;

                    if (scrollAdjust) window.scrollTo(0, window.scrollY + scrollAdjust);
                }

                if (settings.gravityFormId) {
                    GravityFormsMultiStep.resetToStart($form, settings.strictClear);
                }

                removeStyles(node, 'height', 'overflow', 'will-change', 'transition');

                $body.show().css({ opacity: 1, position: '', inset: '', width: '' });
                $form.hide().css({ opacity: 1, position: '', inset: '', width: '' });

                $body.attr('aria-hidden', 'false');
                $form.attr('aria-hidden', 'true');
                $btn.attr('aria-expanded', 'false').removeAttr('aria-disabled');

                overlayOpen = false;
                $btn.trigger('focus');
            });
        }

        // Bind open/close events
        $btn.on('click', function (e) { e.preventDefault(); open(); });
        if ($close.length) {
            $close.on('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
            $close.on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(); }
            });
        }

        // Return public API
        return {
            open: open,
            close: close,
            isOpen: () => overlayOpen,
            destroy: () => {
                unbindDismissHandlers();
                if (settings.enableAutoAdvance) {
                    $(document).off('keydown' + NS_INPUT + ' mousedown' + NS_INPUT + ' touchstart' + NS_INPUT);
                }
                $btn.off('click');
                $close.off('click keydown');
                $wrap.off(NS);
            }
        };
    }

    /**
     * ============================================================================
     * AUTO-INITIALIZE
     * Scans for [data-modal] elements and creates a modal instance for each.
     * Configuration is driven entirely by data attributes on the wrapper element.
     *
     * Required attributes:
     *   data-modal                 — marks the element for auto-init
     *   data-modal-content         — selector for the default content panel (within wrapper)
     *   data-modal-form            — selector for the form panel (within wrapper)
     *   data-modal-trigger         — selector for the button(s) that open this modal
     *
     * Optional attributes:
     *   data-modal-close           — selector for the close button (within wrapper)
     *   data-modal-body-class      — class added to <body> while modal is open (default: modal-anchored-open)
     *   data-modal-namespace       — unique event namespace; auto-generated if omitted
     * ============================================================================
     */
    $('[data-modal]').each(function () {
        const $el  = $(this);

        // Ensure the wrapper has an ID so we can build a unique selector and namespace
        if (!$el.attr('id')) {
            $el.attr('id', 'modal-' + Math.random().toString(36).slice(2, 8));
        }

        // Derive a safe event namespace from the element's ID
        const ns = $el.attr('id').replace(/[^a-zA-Z0-9_-]/g, '');

        createAnchoredModal({
            wrapSelector:    '#' + $el.attr('id'),
            contentSelector: $el.data('modal-content')  || '.body-content',
            formSelector:    $el.data('modal-form') || '.modal-form',
            buttonSelector:  $el.data('modal-trigger') || '.modal-trigger',
            closeSelector:   $el.data('modal-close') || null,
            bodyActiveClass: $el.data('modal-body-class') || 'modal-anchored-open',
            namespace:       '.' + ns,
            inputNamespace:  '.' + ns + 'Input'
        });
    });

    // Expose factory for programmatic use
    window.createAnchoredModal = createAnchoredModal;

});
